import type { TFunction } from 'i18next';

import yup from '../../../../shared/validation';

export function getTrainingSetItemFormValidation(t: TFunction) {
  return yup.object({
    trainingSetItemOptions: yup.array().of(
      yup.object().shape({
        value: yup
          .number()
          .nullable()
          .min(0, t('formikValidation.minValue').replace('{0}', '0')),
      }),
    ),
  });
}
